
import React from 'react';
import { UserPlus } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CustomerFooterProps {
  onCreateNew: () => void;
}

const CustomerFooter = ({ onCreateNew }: CustomerFooterProps) => {
  return (
    <div className="p-4 border-t bg-gray-50">
      <Button 
        onClick={onCreateNew}
        variant="outline"
        className="w-full reference-table-add-button"
      >
        <UserPlus className="h-4 w-4 mr-2" />
        <span>Créer un nouveau client</span>
      </Button>
    </div>
  );
};

export default CustomerFooter;
